export default {
  sm: `
  DATA CENTER GAK would like to become the 
  standard of eco-friendly data centers, 
  taking into account the environment, 
  people, and even successful business.
  `,
  md: `
  DATA CENTER GAK would like to become the 
  standard of eco-friendly data centers, taking 
  into account the environment, people, and 
  even successful business.
  `,
  lg: `
  DATA CENTER GAK would like to become the 
  standard of eco-friendly data centers, taking into
  account the environment, people, and even 
  successful business.
  `,
  xxl: `
  DATA CENTER GAK would like to become the standard of eco-friendly 
  data centers, taking into account the environment, people, and even 
  successful business.
  `,
};
